import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { AddressRepository } from '../repositories/address.repository';
import { CitiesResponse } from '../models/cities-response.model';

export class GetCitiesUseCase implements UseCase<number, CitiesResponse> {
    constructor(private readonly repository: AddressRepository) {}

    execute(stateId: number): Observable<CitiesResponse> {
        return this.repository.getCities(stateId);
    }
}
